module.exports = __webpack_public_path__ + "media/assets/icons/letter-background-4e5a85f53c4b8e2ae2331bfeb2d785ee.svg";